import { render, staticRenderFns } from "./EntradasDeProdutos.vue?vue&type=template&id=51cfd826&scoped=true&"
import script from "./EntradasDeProdutos.vue?vue&type=script&lang=js&"
export * from "./EntradasDeProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfd826",
  null
  
)

export default component.exports